export default "__VITE_ASSET__ee77e67d__"